import React from 'react';
import { Component as ComponentContainer } from '@styles/layout';
import { Icon } from '@components/common/generic-icon';
import { TestId } from '@components/test-ids';
import styled from '@emotion/styled';
import { ContentBenefit } from '@model/content';
import { mq } from '@styles/breakpoints';
import { ThemeProps } from '@theme/base';

export interface BenefitsSidebarProps {
  title: string;
  benefits: Array<ContentBenefit>;
}

const Container = styled.div(({ theme }: ThemeProps) => ({
  padding: theme.custom.spacing.xLarge,
  backgroundColor: theme.custom.colors.group10.lighter,
  marginTop: theme.custom.spacing.xxLarge,
  [mq.large]: {
    marginTop: 0
  }
}));

const Title = styled.h4(({ theme }: ThemeProps) => ({
  ...(theme.custom.typography.h4 as any),
  marginBottom: theme.custom.spacing.xLarge,
  marginTop: 0
}));

const BenefitContainer = styled.div(({ theme }: ThemeProps) => ({
  display: 'flex',
  marginBottom: theme.custom.spacing.xLarge,
  ['&:last-of-type']: {
    marginBottom: 0
  }
}));

const DescriptionContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  width: '100%'
});

const BenefitTitle = styled.h5(({ theme }: ThemeProps) => ({
  ...(theme.custom.typography.h5 as any),
  margin: 0,
  color: theme.custom.colors.group4.base
}));

const BenefitDetail = styled.p(({ theme }: ThemeProps) => ({
  ...(theme.custom.typography.paragraph as any),
  marginTop: theme.custom.spacing.xSmall
}));

const BenefitIcon = styled(Icon)(({ theme }: ThemeProps) => ({
  fontSize: '3rem',
  marginRight: theme.custom.spacing.large,
  color: theme.custom.states.info.dark
}));

export const BenefitsSidebar = ({ benefits, title }: BenefitsSidebarProps) => {
  const renderBenefits = () =>
    benefits.map(({ title, icon, details }: ContentBenefit) => (
      <BenefitContainer key={title}>
        <BenefitIcon name={icon} />
        <DescriptionContainer>
          <BenefitTitle>{title}</BenefitTitle>
          <BenefitDetail>{details}</BenefitDetail>
        </DescriptionContainer>
      </BenefitContainer>
    ));
  return (
    <ComponentContainer>
      <Container data-testid={TestId.benefitsSidebar}>
        <Title>{title}</Title>
        {renderBenefits()}
      </Container>
    </ComponentContainer>
  );
};
